import * as React from 'react';
import { noopFunction } from '@hawkins/helpers';
export var AccordionContext = React.createContext({
    baseId: 'Hawkins-Accordion',
    disabled: false,
    expanded: null,
    onChange: noopFunction,
    panelId: undefined,
    setSubtitleId: noopFunction,
    setTitleId: noopFunction,
});
